import type { ApiResponse, IPayment } from './types';
import routes from '@/config/routes';
import { v3Get, v3Post } from './axios.instance.V3';

const getCoursesList = (gigId: number, applicationId: number): ApiResponse =>
  v3Get(`gig/${gigId}/${routes.backendUrl.courseDetails.list}/${applicationId}`);
const makePayment = (payload: IPayment): ApiResponse =>
  v3Post(`${routes.backendUrl.courseDetails.makePayment}`, payload);
const getRescheduleCoursesList = (gigId: number): ApiResponse =>
  v3Get(`gig/${gigId}/${routes.backendUrl.courseDetails.rescheduleList}`);

export const courseApis = {
  getCoursesList,
  getRescheduleCoursesList,
  makePayment,
};
